export const fallBackUrls = {
  lidl: {
    imprintUrl: 'https://info.lidl/en/imprint',
    privacyUrl: 'https://info.lidl/en/privacy-protection',
    quitUrl: 'https://info.lidl/en',
  },
  kaufland: {
    imprintUrl: 'https://www.kaufland.com/legal-notice.html',
    privacyUrl: 'https://www.kaufland.com/privacy-policy.html',
    quitUrl: 'https://www.kaufland.com',
  },
  parkside: {
    imprintUrl: 'https://parkside-diy.com/imprint',
    privacyUrl: 'https://parkside-diy.com/data-policy',
    quitUrl: 'https://parkside-diy.com',
  },
  silvercrest: {
    imprintUrl: 'https://my-silvercrest.com/imprint',
    privacyUrl: 'https://my-silvercrest.com/data-privacy',
    quitUrl: 'https://my-silvercrest.com',
  },
};
